import { useIntl } from 'react-intl'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
import { IndividualTransactions } from '../components/individual/transactions-individuals'
import { IndividualBankDetails } from '../components/individual/bank-individuals'
import { useEffect, useState } from 'react'
import { useThemeMode } from '../../../../../_metronic/partials'
import { ShareholdersTypes, StakeholdersDetailsBreadCrum } from '../core/_constants'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { useNavigate, useParams } from 'react-router-dom'
import { useDateFormat } from '../../../../hooks/useDateFormat'
import { useAuth } from '../../../auth'
import { getSharholderBankDetails, getSharholderDetails } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import { IndividualNote } from '../components/individual/note-individuals'
import { IndividualAttatchments } from '../components/individual/attatchments-individuals'
import { StakeholderModuleTypes } from '../../../../core/_constants'
import { InstitutionProfile } from '../components/institutional/profile-institution'

export const InstitutionalDetails = () => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [shareholderDetailsLoading, setShareholderDetailsLoading] = useState(false)
  const [shareholderDetails, setShareholderDetails] = useState<any>(null)
  const [shareholderBankDetails, setShareholderBankDetails] = useState<any>(null)
  const [shareholderBankDetailsLoading, setShareholderBankDetailsLoading] = useState(false)
  const { getDateValue } = useDateFormat()
  const navigate = useNavigate()
  const { shareholderId } = useParams()
  const sidebarOptions = [
    { title: formatMessage({ id: 'Transactions' }) },
    { title: formatMessage({ id: 'Profile' }) },
    { title: formatMessage({ id: 'Attachments' }) },
    { title: formatMessage({ id: 'Bank Account' }) },
    { title: formatMessage({ id: 'Internal Notes' }) },
  ]

  const { mode } = useThemeMode()
  const [sidebar, setSidebar] = useState(1)

  const fetchShareholder = async () => {
    if (!shareholderId || !companyId) return
    setShareholderDetailsLoading(true)
    try {
      const {
        data: { data, success },
      } = await getSharholderDetails(shareholderId, companyId)
      if (success) {
        setShareholderDetails(data)
        setShareholderDetailsLoading(false)
      }
    } catch (error) {
      console.error('Error fetching countries:', error)
    } finally {
      setShareholderDetailsLoading(false)
    }
  }

  useEffect(() => {


    fetchShareholder()
  }, [shareholderId]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchBankDetails = async (bankDetailId?: string) => {
    if (!shareholderDetails?.bankDetailId) return
    setShareholderBankDetailsLoading(true)
    try {
      const {
        data: { data, success },
      } = await getSharholderBankDetails(
        shareholderId!,
        companyId!,
        bankDetailId ?? shareholderDetails?.bankDetailId
      )
      if (success) {
        setShareholderBankDetails(data)
        setShareholderBankDetailsLoading(false)
      }
    } catch (error) {
      console.error('Error fetching countries:', error)
    } finally {
      setShareholderBankDetailsLoading(false)
    }
  }

  useEffect(() => {
    fetchBankDetails()
  }, [shareholderDetails?.bankDetailId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={StakeholdersDetailsBreadCrum}
        description={formatMessage({ id: 'Shareholder Details' })}
      >
        {formatMessage({ id: 'Shareholder Details' })}
      </PageTitle>

      <div className='mt-4 mb-8'>
        <div className='bg-white w-100 p-4 rounded-2 custom-border-radius-institutional'>
          <div className='d-md-flex justify-content-between w-100 align-items-center  mb-4'>
            <h2 className='font-size-16'>{formatMessage({ id: 'Shareholder details' })}</h2>
            <button
              className='btn btn-light justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-md-auto w-100'
              onClick={() =>
                navigate(
                  `/stakeholders/add-stakeholder?tab=institution&shareholderId=${shareholderDetails?.shareholderId}&edit=true`
                )
              }
            >
              {formatMessage({ id: 'Edit' })}
            </button>
          </div>

          <div className='d-md-flex gap-4'>
            {shareholderDetailsLoading ? (
              <Skeleton
                height={120}
                width={120}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <DisplayImage
                imgName={shareholderDetails?.individual?.profileImage?.name}
                width='120px'
                height={120}
                alt='investor logo'
                fit='contain'
                className='mb-4'
              />
            )}
            <div className='w-100'>
              <div className='d-flex gap-2 align-items-center'>
                {shareholderDetailsLoading ? (
                  <Skeleton
                    height={30}
                    width={120}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <h2 className='font-size-20 m-0'>
                    {shareholderDetails?.institution?.legalName || '-'}
                  </h2>
                )}
                {shareholderDetailsLoading ? (
                  <Skeleton
                    height={30}
                    width={60}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <div
                    className={`badge ${shareholderDetails?.type === ShareholdersTypes.INSTITUTIONAL
                      ? 'badge-light-success'
                      : 'badge-light-primary'
                      } px-4 py-2 text-capitalize`}
                  >
                    {shareholderDetails?.type}
                  </div>
                )}
              </div>
              <div className='pe-4 pt-2'>
                {shareholderDetailsLoading ? (
                  <Skeleton
                    height={20}
                    width={90}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <a
                    href={
                      shareholderDetails?.individual?.website?.startsWith('http')
                        ? shareholderDetails?.individual?.website
                        : `https://${shareholderDetails?.individual?.website}`
                    }
                    target='_blank'
                    rel='noreferrer'
                    className='text-primary m-0'
                  >
                    {shareholderDetails?.individual?.website}
                  </a>
                )}
              </div>

              <div className='d-flex d-md-block'>
                <div className='w-100 my-6'>
                  <div className='row gap-10 justify-content-between'>
                    <div className='col-lg-2 col-md-2 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'PoC Name' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={30}
                          width={120}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>
                          {shareholderDetails?.individual?.firstName}{' '}
                          {shareholderDetails?.individual?.lastName}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-2 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'PoC Email Id' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={140}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>{shareholderDetails?.individual?.email}</p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'PoC Phone' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={120}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0'>
                          <p className='font-size-13 mb-0 text-wrap'>
                            {shareholderDetails?.individual?.phoneNumber
                              ? `${shareholderDetails.individual.phoneNumber}`
                              : '-'}
                          </p>
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'PoC Designation' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={140}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>
                          {shareholderDetails?.designation || '-'}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'PoC Nationality' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={130}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>
                          {shareholderDetails?.individual?.nationality?.label || '-'}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className='w-100 my-6'>
                  <div className='row gap-10 justify-content-between'>
                    <div className='col-lg-2 col-md-2 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Registered Address' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={130}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>
                          {!shareholderDetails?.individual?.address1 &&
                            !shareholderDetails?.individual?.address2 &&
                            !shareholderDetails?.individual?.city &&
                            !shareholderDetails?.individual?.state?.label &&
                            !shareholderDetails?.individual?.country?.label &&
                            !shareholderDetails?.individual?.zipCode
                            ? '-'
                            : `${shareholderDetails?.institution?.address1
                              ? `${shareholderDetails?.institution?.address1},`
                              : ''
                            } ${shareholderDetails?.institution?.address2
                              ? `${shareholderDetails?.institution?.address2},`
                              : ''
                            } ${shareholderDetails?.institution?.city
                              ? `${shareholderDetails?.institution?.city},`
                              : ''
                            } ${shareholderDetails?.institution?.state?.label
                              ? `${shareholderDetails?.institution?.state?.label},`
                              : ''
                            }${shareholderDetails?.institution?.country?.label
                              ? `${shareholderDetails?.institution?.country?.label},`
                              : ''
                            } ${shareholderDetails?.institution?.zipCode
                              ? `${shareholderDetails?.institution?.zipCode},`
                              : ''
                            }`}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0 min-w-200px min-w-md-200px'>
                        {formatMessage({ id: "Institution's Domicile" })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={130}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>
                          {shareholderDetails?.institution?.domicile?.label || '-'}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Referred By' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={130}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-14 mb-0 text-wrap'>{shareholderDetails?.referredBy || '-'}</p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Best Contact Channel' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={190}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-13 mb-0 text-wrap'>
                          {shareholderDetails?.institutionBestContactChannel || '-'}
                        </p>
                      )}
                    </div>
                    <div className='col-lg-2 col-md-6 mb-4 mb-md-auto'>
                      <p className='text muted font-size-12 mb-0'>
                        {formatMessage({ id: 'Last Heard Date' })}
                      </p>
                      {shareholderDetailsLoading ? (
                        <Skeleton
                          height={20}
                          width={190}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <p className='font-size-13 mb-0 text-wrap'>
                          {shareholderDetails?.lastHeardDate
                            ? getDateValue(shareholderDetails?.lastHeardDate)
                            : '-'}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='rounded-bottom mb-3 sidebar-investor-db col-md-1 d-flex bg-white' style={{ width: '100%' }}>
          <div
            className=' d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul

                  className={`nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent flex-nowrap mobile-tab-both my-md-0 mb-0 px-2 ${mode === 'dark' ? 'text-muted' : 'text-muted'
                    }`}
                  style={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                  <li
                    key={index}
                    className={
                      `nav-link text-active-primary cursor-pointer py-3 ps-3 d-flex align-items-center` +
                      (sidebar === index + 1
                        ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                        : '')
                    }
                    onClick={() => setSidebar(index + 1)}
                  >
                    {sideTabs.title}
                  </li>
                </ul>
              </>
            ))}
          </div>
        </div>
        <div
          className={`d-flex mb-4 rounded-2 w-100 ` + (mode !== 'dark' ? `bg-white` : ``)}
          style={{ background: '#323248' }}
        >
          {sidebar === 1 ? (
            <div className='d-flex flex-column w-100'>
              <div className='w-100'>
                <IndividualTransactions />
              </div>
            </div>
          ) : sidebar === 2 ? (
            <div className='w-100'>
              <div className='w-100'>
                {' '}
                <InstitutionProfile
                  shareholderDetails={shareholderDetails}
                  shareholderDetailsLoading={shareholderDetailsLoading}
                />
              </div>
            </div>
          ) : sidebar === 3 ? (
            <div className='w-100'>
              <div className='w-100'>
                {' '}
                <IndividualAttatchments
                  stakeholdersDetails={shareholderDetails}
                  type={StakeholderModuleTypes.SHAREHOLDER}
                  loading={shareholderDetailsLoading}
                  id={shareholderId!}
                  fetchTeamMemberDetails={fetchShareholder}
                />
              </div>
            </div>
          ) : sidebar === 4 ? (
            <div className='w-100'>
              <div className='w-100'>
                {' '}
                <IndividualBankDetails
                  shareholderBankDetails={shareholderBankDetails}
                  fetchBankDetails={fetchBankDetails}
                  shareholderBankDetailsLoading={shareholderBankDetailsLoading}
                />
              </div>
            </div>
          ) : (
            <div className='w-100'>
              <div className='w-100'>
                {' '}
                <IndividualNote
                  shareholderBankDetails={shareholderBankDetails}
                  fetchBankDetails={fetchBankDetails}
                  shareholderBankDetailsLoading={shareholderBankDetailsLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
